export default "__VITE_ASSET__BXInylwM__"